<template>
  <b-modal size="lg" v-model="show" centered title="Neue Adresse"
  >
    <div  v-if="isAGeber">
      <b-row class="justify-content-md-center">
        <b-col>
          <b-row>
            <b-col sm="4">
              <label for="anrede">Anrede</label>
              <b-form-select :options="anrede_select" id="anrede" :plain="true"
                             v-model="address.salutation"
                             class="mb-2 text-black"
              ></b-form-select>
            </b-col>
            <b-col sm="8">
              <label for="pk_nr">Debitor</label>
              <b-form-input id="pk_nr" type="text"
                            v-model="address.debitor"
                            class="mb-2 text-black"
                            maxlength="20"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.debitor.length}}/20</b-form-text>
            </b-col>
          </b-row>
          <label for="name">Name 1</label>
          <b-form-input id="name" type="text"
                        v-model="address.first_name"
                        class="mb-2 text-black"
                        maxlength="30"
          ></b-form-input>
          <b-form-text style="text-align: right">{{address.first_name.length}}/30</b-form-text>
          <label for="name">Name 2</label>
          <b-form-input id="name" type="text"
                        v-model="address.name_1"
                        class="mb-2 text-black"
                        maxlength="30"
          ></b-form-input>
          <b-form-text style="text-align: right">{{address.name_1.length}}/30</b-form-text>
          <b-row>
            <b-col sm="8">
              <label for="plz">Straße</label>
              <b-form-input id="plz" type="text"
                            v-model="address.street"
                            class="mb-2 text-black"
                            maxlength="20"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.street.length}}/30</b-form-text>
            </b-col>
            <b-col sm="4">
              <label for="ort">Hausnummer</label>
              <b-form-input id="ort" type="text"
                            v-model="address.street_number"
                            class="mb-2 text-black"
                            maxlength="10"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.street_number.length}}/10</b-form-text>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="4">
              <label for="plz">PLZ</label>
              <b-form-input id="plz" type="text"
                            v-model="address.zip_code"
                            class="mb-2 text-black"
                            maxlength="5"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.zip_code.length}}/5</b-form-text>
            </b-col>
            <b-col sm="8">
              <label for="ort">Ort</label>
              <b-form-input id="ort" type="text"
                            v-model="address.city"
                            class="mb-2 text-black"
                            maxlength="30"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.city.length}}/30</b-form-text>
            </b-col>
          </b-row>
          <label for="name">Email</label>
          <b-form-input id="name" type="email"
                        v-model="address.email"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{address.email.length}}/60</b-form-text>
        </b-col>
      </b-row>
    </div>
    <div  v-else>
      <b-row class="justify-content-md-center">
        <b-col>
          <b-row>
            <b-col sm="4">
              <label for="anrede">Anrede</label>
              <b-form-select :options="anrede_select" id="anrede" :plain="true"
                             v-model="address.salutation"
                             class="mb-2 text-black"></b-form-select>
            </b-col>
            <b-col sm="8">
              <label for="pk_nr">PK-Nr.</label>
              <b-form-input id="pk_nr" type="text"
                            v-model="address.debitor"
                            class="mb-2 text-black"
                            maxlength="20"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.debitor.length}}/20</b-form-text>
            </b-col>
          </b-row>
          <label for="name">Name</label>
          <b-form-input id="name" type="text"
                        v-model="address.first_name"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{address.first_name.length}}/60</b-form-text>

          <label for="name">zu Händen von</label>
          <b-form-input id="name" type="text"
                        v-model="address.name_1"
                        class="mb-2 text-black"
                        maxlength="60"
          ></b-form-input>
          <b-form-text style="text-align: right">{{address.name_1.length}}/60</b-form-text>
          <b-row>
            <b-col sm="8">
              <label for="plz">Straße</label>
              <b-form-input id="plz" type="text"
                            v-model="address.street"
                            class="mb-2 text-black"
                            maxlength="20"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.street.length}}/30</b-form-text>
            </b-col>
            <b-col sm="4">
              <label for="ort">Hausnummer</label>
              <b-form-input id="ort" type="text"
                            v-model="address.street_number"
                            class="mb-2 text-black"
                            maxlength="10"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.street_number.length}}/10</b-form-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="2">
              <label for="land">Ländercode</label>
              <b-form-input id="land" type="text"
                            v-model="address.country"
                            class="mb-2 text-black"
                            placeholder="z.B. DE"
                            maxlength="3"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.country.length}}/3</b-form-text>
            </b-col>
            <b-col sm="2">
              <label for="plz">PLZ</label>
              <b-form-input id="plz" type="text"
                            v-model="address.zip_code"
                            class="mb-2 text-black"
                            maxlength="5"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.zip_code.length}}/5</b-form-text>
            </b-col>
            <b-col sm="8">
              <label for="ort">Ort</label>
              <b-form-input id="ort" type="text"
                            v-model="address.city"
                            class="mb-2 text-black"
                            maxlength="80"
              ></b-form-input>
              <b-form-text style="text-align: right">{{address.city.length}}/80</b-form-text>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>

export default {
  props: {
    isAGeber: Boolean,
  },
  name: "CreateAddressDialog",
  data() {
    return {
      show: false,
      anrede_select: ["Firma", "An den", "An die", "An das", "Herr", "Frau"],
      address: {
        name: '',
        debitor: '',
        salutation: '',
        name_1: '',
        first_name: '',
        country: '',
        street: '',
        street_number: '',
        zip_code: '',
        city: '',
        phone_number: '',
        phone_p: '',
        fax: '',
        email: '',
      }
    }
  },
  methods: {
    showModal() {
      this.address = {
        name: '',
        debitor: '',
        salutation: '',
        name_1: '',
        first_name: '',
        country: '',
        street: '',
        street_number: '',
        zip_code: '',
        city: '',
        phone_number: '',
        phone_p: '',
        fax: '',
        email: '',
      };
      this.show = true;
    },
    getReturnData() {
      return this.address;
    },
    async onSave() {
      let data = this.getReturnData();
      this.$emit('create-address', data);
      this.show = false;
    },

    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>
.text-black {
  color: black;
}
.vld-overlay.is-full-page {
  z-index: 1600;
  position: fixed;
}
</style>
